(function () {
  if (window.__caseSizeSwatchInit) return;
  window.__caseSizeSwatchInit = true;

  function normalize(t){ return (t || '').toString().toLowerCase().trim(); }

  function markCaseSize(root){
    (root || document).querySelectorAll('fieldset.swatch:not(.is-case-size-checked)').forEach(function(fs){
      fs.classList.add('is-case-size-checked');
      var nameEl = fs.querySelector('.options-selection__option-name');
      if(!nameEl) return;

      var a = normalize(nameEl.dataset.variantOptionName);
      var b = normalize(nameEl.dataset.variantOptionChooseName);
      var c = normalize(nameEl.textContent);

      // Accept "case size" OR plain "size" (including "size: small")
      var isCase =
        a.includes('case size') || b.includes('case size') || c.includes('case size') ||
        a === 'size' || b === 'size' || c === 'size' ||
        a.startsWith('size') || b.startsWith('size') || c.startsWith('size');

      if(isCase) fs.classList.add('is-case-size');
    });
  }

  function setupObserver(){
    var obs = new MutationObserver(function(muts){
      var changed = false;
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        if ((m.addedNodes && m.addedNodes.length) ||
            (m.target && m.target.nodeType === 1)) { changed = true; break; }
      }
      if (changed) markCaseSize(document);
    });
    obs.observe(document.documentElement, {childList:true, subtree:true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ markCaseSize(document); setupObserver(); });
  } else {
    markCaseSize(document); setupObserver();
  }

  document.addEventListener('shopify:section:load', function(e){ markCaseSize(e.target); });
})();